import { AnsweringClient } from "../clients/answeringClient";
import { AuthRetry, SessionExpiredError } from "../utils/authRetry";

export interface AllowFeedbackResponse {
  allowFeedback: boolean;
  defaultFeedback: boolean;
  applicationAllowFeedback: boolean;
}

export interface FinishScreenControllerDelegate {
  applicationShouldLogout(): void;
  genericError(message?: string): void;
  feedbackInactive(message: string): void;
  didGetAllowFeedback(data: AllowFeedbackResponse): void;
  didGetAssignmentToken(token: string): void;
  didClickSeeResults(assignmentId: number): void;
}

export class FinishScreenController {
  private readonly auth: AuthRetry;

  constructor(
    private delegate: FinishScreenControllerDelegate,
    private readonly answeringClient = new AnsweringClient()
  ) {
    this.auth = new AuthRetry(this.answeringClient, () =>
      this.delegate.applicationShouldLogout()
    );
  }

  public async getAllowFeedback(accessToken: string, applicationId: number) {
    try {
      const response = await this.auth.run(accessToken, (token) =>
        this.answeringClient.getAllowFeedback(token, applicationId)
      );
      this.delegate.didGetAllowFeedback(response.data);
    } catch (error: any) {
      this.reportError(error);
    }
  }

  public async getAssignmentFeedbackToken(
    accessToken: string,
    assignmentId: number
  ) {
    try {
      const response = await this.auth.run(accessToken, (token) =>
        this.answeringClient.getAssignmentFeedbackToken(token, assignmentId)
      );
      this.delegate.didGetAssignmentToken(response.data.token);
    } catch (error: any) {
      if (error?.response?.status === 422) {
        this.delegate.feedbackInactive(
          "O acesso à devolutiva está inativo nesta aplicação."
        );
        return;
      }
      this.reportError(error);
    }
  }

  didClickSeeResults(assignmentId: number) {
    this.delegate.didClickSeeResults(assignmentId);
  }

  /** Swallows SessionExpiredError rather than reporting it; see its declaration. */
  private reportError(error: any): void {
    if (error instanceof SessionExpiredError) {
      return;
    }
    this.delegate.genericError(error?.response?.data?.message);
  }
}
